function initSubmitHandling(form) {
	form.addEventListener('submit', () => {
		disableForm(form);

		setTimeout(() => {
			enableForm(form);
		}, 5000);
	});
}

function disableForm(form) {
	const submit = form.querySelector('[type="submit"]');

	form.classList.add('is-loading');

	if (submit) {
		submit.setAttribute('disabled', 'disabled');
	}
}

function enableForm(form) {
	const submit = form.querySelector('[type="submit"]');

	form.classList.remove('is-loading');

	if (submit) {
		submit.removeAttribute('disabled');
	}
}

export { initSubmitHandling, disableForm, enableForm };
